// Premium gradient backgrounds for hero sections
// Inspired by Stripe/Linear — modern fintech aesthetic
// No image files needed → resolution-independent, instant load

const heroGradients = {
  // Home + On-The-Fly — warm premium with subtle radial glow
  main: `
    radial-gradient(ellipse at 20% 50%, rgba(252, 211, 77, 0.15) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 20%, rgba(252, 211, 77, 0.08) 0%, transparent 40%),
    linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%)
  `,

  // FAQ + Blog — cool navy with constellation feel
  faq: `
    radial-gradient(ellipse at 70% 30%, rgba(99, 102, 241, 0.12) 0%, transparent 50%),
    radial-gradient(ellipse at 30% 70%, rgba(252, 211, 77, 0.06) 0%, transparent 40%),
    linear-gradient(160deg, #0f172a 0%, #1e1b4b 50%, #0f172a 100%)
  `,

  // Privacy — teal-tinted security feel
  privacy: `
    radial-gradient(ellipse at 50% 50%, rgba(20, 184, 166, 0.1) 0%, transparent 50%),
    radial-gradient(ellipse at 80% 80%, rgba(252, 211, 77, 0.05) 0%, transparent 40%),
    linear-gradient(145deg, #0f172a 0%, #134e4a 40%, #0f172a 100%)
  `,

  // Terms — professional dark with subtle silver
  terms: `
    radial-gradient(ellipse at 40% 40%, rgba(148, 163, 184, 0.08) 0%, transparent 50%),
    radial-gradient(ellipse at 70% 70%, rgba(252, 211, 77, 0.04) 0%, transparent 40%),
    linear-gradient(150deg, #0f172a 0%, #1e293b 60%, #0f172a 100%)
  `,

  // Contact — warm amber accent
  contact: `
    radial-gradient(ellipse at 70% 60%, rgba(251, 191, 36, 0.12) 0%, transparent 50%),
    radial-gradient(ellipse at 20% 30%, rgba(99, 102, 241, 0.06) 0%, transparent 40%),
    linear-gradient(140deg, #0f172a 0%, #1e293b 50%, #1c1917 100%)
  `,

  // Download CTA — golden sunrise
  download: `
    radial-gradient(ellipse at 50% 100%, rgba(252, 211, 77, 0.2) 0%, transparent 60%),
    radial-gradient(ellipse at 80% 0%, rgba(251, 146, 60, 0.08) 0%, transparent 40%),
    linear-gradient(180deg, #0f172a 0%, #292524 100%)
  `,
};

export default heroGradients;
